export class Reset {
    constructor(
        public email: string,
        public cpf: string
    ) {}
}
